import axios from "axios";

export const deleteModuleById = async (id) => {
  try {
    const response = await axios.delete(`http://localhost:8080/webnet-hms/api/modules/${id}`);
    window.alert("Module deleted successfully!");
    return response.data;
  } catch (error) {
    console.error("Error deleting module:", error);
    window.alert("Failed to delete module.");
  }
};
